import React, { FC, useCallback } from 'react'

import { Header, InterSvgIcon, Loader, ErrorHandler } from 'components'
import { Page, PageContent, makeTraceDetails } from 'common'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { Routes } from 'common/constants'
import { useNavigate } from 'react-router-dom'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { isEmpty } from 'lodash'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import { MainContent } from './styles'

export const SuccessReportRequested: FC = () => {
  const { privacyCenterContent, isAppLoading, isAppError, isAppActive, userSelectedEntity } =
    useAppContext()

  const navigate = useNavigate()

  const routeHistoricoRelatorios = Routes.REPORTS_HISTORY

  const closeHandler = useCallback(async () => {
    try {
      await sendSelectContent({
        flow: 'success_report_requested',
        step: 'success_report_requested',
        screen_name: Routes.SUCCESS_REPORT_REQUESTED,
        element_name: 'closeSuccessReportRequested',
        element_type: 'button',
        parent_name: 'SuccessReportRequested',
        scenario: JSON.stringify({
          screen: Routes.SUCCESS_REPORT_REQUESTED,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send success report requested close tic', error)
    }

    navigate(Routes.REPORTS_HISTORY, { state: { goToRequestedReports: true } })
  }, [navigate, userSelectedEntity])

  useScreenFinishLoadTac({
    name: 'SuccessReportRequested',
    entity: userSelectedEntity,
    action: 'SuccessReportRequested',
    screen: Routes.SUCCESS_REPORT_REQUESTED,
    shouldSend: true,
    logLabel: 'send success report requested tac',
  })

  if (isAppLoading) return <Loader />

  const content = privacyCenterContent?.components?.requestedReportSuccessFeedback?.content

  const isActive = privacyCenterContent?.components?.yourPersonalData

  const isErrorOrInactive = isAppError || isEmpty(content) || !isActive || !isAppActive

  if (isErrorOrInactive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={SuccessReportRequested.name} />
  }

  const { title, details, confirmButton, icon } = content

  return (
    <Page>
      <Header title="" goToPath={routeHistoricoRelatorios} />
      <PageContent>
        <MainContent>
          {icon && <InterSvgIcon iconRef={icon} height={64} width={64} color="var(--success500)" />}
          <Text variant="headline-h1" color="typography" semiBold>
            {title}
          </Text>
          <Text variant="body-3" color="typography">
            {details}
          </Text>
        </MainContent>
        <Button
          variant="primary"
          color="typography"
          style={{ marginBottom: '1rem' }}
          onClick={closeHandler}
        >
          {confirmButton}
        </Button>
      </PageContent>
    </Page>
  )
}
